import { render, staticRenderFns } from "./DatabasePublishDialog.vue?vue&type=template&id=60a4eddb&scoped=true"
import script from "./DatabasePublishDialog.vue?vue&type=script&lang=js"
export * from "./DatabasePublishDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60a4eddb",
  null
  
)

export default component.exports